import Vue from 'vue';
import VueI18n from 'vue-i18n';

let lang = localStorage.getItem('lang');
if (lang === null) {
    lang = navigator.language;
    localStorage.setItem('lang', lang);
}

Vue.use(VueI18n);

export default new VueI18n({
    locale: lang, // set locale
    fallbackLocale: 'en',
    silentFallbackWarn: true,
});
